import { CartAddEvent } from '@theme/events';

function initialise(root) {
  if (root.dataset.bound) return;
  root.dataset.bound = 'true';
  const form = document.getElementById(root.dataset.formId);
  if (!form) return;
  const variants = JSON.parse(root.querySelector('[data-pdp-variants]').textContent);
  const requiredPlan = JSON.parse(root.querySelector('[data-pdp-plan-required]').textContent);
  const variantInput = form.querySelector('[name="id"]');
  const quantity = form.querySelector('[name="quantity"]');
  const add = form.querySelector('[data-pdp-add]');
  const buyButton = form.querySelector('[data-pdp-buy-now]');
  const status = form.querySelector('[data-pdp-status]');
  const sticky = root.querySelector('[data-pdp-sticky]');
  const stickyAdd = root.querySelector('[data-pdp-sticky-add]');
  const stickyLabel = root.querySelector('[data-pdp-sticky-label]');
  const panels = [...root.querySelectorAll('[data-pdp-panel]')];
  const thumbs = [...root.querySelectorAll('[data-pdp-thumb]')];
  let activeIndex = 0;
  let busy = false;
  let uncertainAdd = false;
  let variant = variants.find(item => String(item.id) === variantInput.value) || variants[0];
  const shippingCue = root.querySelector('[data-pdp-shipping]');
  const shippingMessage = root.querySelector('[data-pdp-shipping-message]');
  const shippingProgress = root.querySelector('[data-pdp-shipping-progress]');
  const routineCards = [...root.querySelectorAll('[data-pdp-routine]')];
  const routinePicker = root.querySelector('[data-pdp-routine-picker]');
  if (routinePicker) new MutationObserver(() => { const message = root.querySelector('[data-pdp-routine-status]'); if (message) message.textContent = status.textContent; }).observe(status,{childList:true,subtree:true,characterData:true});
  routinePicker?.querySelectorAll('img').forEach(image => { image.loading = 'eager'; });
  let selectedRoutine = routineCards.find(card => card.getAttribute('aria-pressed') === 'true') || routineCards[0] || null;
  const routineIds = card => (card?.dataset.routineVariantIds || '').split(',').map(id => id.trim()).filter(Boolean);
  routineCards.forEach(card => { card.dataset.addonPrice = String(Number(card.dataset.routinePrice) - variant.price); card.dataset.addonsAvailable = card.dataset.routineAvailable; });
  root.querySelector('[data-pdp-routine-add]')?.addEventListener('click', () => { if (!add.disabled) form.requestSubmit(add); });
  routineCards.forEach(card => card.addEventListener('click', () => {
    selectedRoutine = card;
    routineCards.forEach(item => { item.classList.toggle('is-selected', item === card); item.setAttribute('aria-pressed', String(item === card)); });
    const unavailable = card.dataset.routineAvailable !== 'true';
    const routineStatus = root.querySelector('[data-pdp-routine-status]');
    if (routineStatus) routineStatus.textContent = unavailable ? 'One or more products in this routine is currently unavailable.' : '';
    if (unavailable) card.setAttribute('data-routine-blocked', 'true'); else card.removeAttribute('data-routine-blocked');
    updateVariant();
  }));
  let shippingCart = null;
  let shippingActual = false;
  function updateShipping(cart, actual = false) {
    if (!shippingCue) return;
    if (cart) shippingCart = cart;
    shippingActual = actual;
    const selection = Number(selectedRoutine?.dataset.routinePrice ?? variant.price) * Number(quantity.value || 1);
    const total = Number(shippingCart?.total_price || 0) + (actual || !variant.available || selectedRoutine?.dataset.routineBlocked === 'true' ? 0 : selection);
    const better = Number(shippingCue.dataset.betterThreshold || 49900);
    const free = Number(shippingCue.dataset.freeThreshold || 99900);
    const remaining = Math.max(0, free - total);
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {style:'currency', currency:window.Shopify?.currency?.active || 'INR', maximumFractionDigits:0}).format(Math.max(0,cents) / 100);
    const basis = actual ? 'Your cart: ' : 'After adding this selection: ';
    shippingMessage.textContent = basis + (total >= free ? 'Free shipping unlocked.' : total >= better ? '₹79 shipping. Add ' + money(remaining) + ' more for free shipping.' : '₹149 shipping. Add ' + money(better-total) + ' more for ₹79 shipping.');
    shippingProgress.style.width = Math.min(100, total / free * 100) + '%';
    const meter = shippingCue.querySelector('[role="progressbar"]');
    if (meter) meter.setAttribute('aria-valuenow', String(Math.min(free,total)));
  }

  function showPanel(index) {
    activeIndex = (index + panels.length) % panels.length;
    const ratio = Number(panels[activeIndex]?.dataset.imageRatio || 1);
    root.querySelector('.hp-pdp__stage').style.setProperty('--pdp-image-ratio', String(Math.max(.75, Math.min(1.5, ratio))));
    panels.forEach((panel, i) => {
      panel.hidden = i !== activeIndex;
      if (i !== activeIndex) panel.querySelector('video')?.pause();
    });
    thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === activeIndex)));
    const position = root.querySelector('[data-pdp-position]');
    if (position) position.textContent = String(activeIndex + 1);
  }
  thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => showPanel(i)));
  root.querySelector('[data-pdp-prev]')?.addEventListener('click', () => showPanel(activeIndex - 1));
  root.querySelector('[data-pdp-next]')?.addEventListener('click', () => showPanel(activeIndex + 1));
  root.querySelector('.hp-pdp__gallery')?.addEventListener('keydown', event => {
    if (!event.target.matches('button')) return;
    if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
      event.preventDefault();
      showPanel(activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
      thumbs[activeIndex]?.focus({preventScroll: true});
    }
  });
  let touchStart = null;
  const stage = root.querySelector('.hp-pdp__stage');
  stage.addEventListener('pointerdown', event => {
    if (event.pointerType === 'touch' && !event.target.closest('button,video,iframe,model-viewer')) touchStart = {x:event.clientX,y:event.clientY};
  });
  stage.addEventListener('pointerup', event => {
    if (!touchStart) return;
    const dx = event.clientX - touchStart.x;
    const dy = event.clientY - touchStart.y;
    touchStart = null;
    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) showPanel(activeIndex + (dx < 0 ? 1 : -1));
  });
  stage.addEventListener('pointercancel', () => {touchStart = null;});

  function clampQuantity() {
    const min = Number(quantity.min || 1);
    const step = Number(quantity.step || 1);
    const max = quantity.max ? Number(quantity.max) : Infinity;
    const value = Number(quantity.value);
    const valid = Number.isFinite(value) ? min + Math.max(0, Math.floor((value - min) / step)) * step : min;
    quantity.value = String(Math.max(min, Math.min(max, valid)));
    root.querySelectorAll('[data-pdp-preset]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.pdpPreset === quantity.value)));
    updateShipping(null);
    const total = root.querySelector('[data-fresh-pack-total]');
    if (total) {
      const money = new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {style:'currency',currency:window.Shopify?.currency?.active || 'INR',maximumFractionDigits:2}).format(variant.price * Number(quantity.value) / 100);
      total.textContent = quantity.value + ' packs · Total ' + money;
    }
  }
  root.querySelector('[data-pdp-minus]')?.addEventListener('click', () => {
    quantity.value = String(Number(quantity.value || quantity.min) - Number(quantity.step || 1));
    clampQuantity();
  });
  root.querySelector('[data-pdp-plus]')?.addEventListener('click', () => {
    quantity.value = String(Number(quantity.value || quantity.min) + Number(quantity.step || 1));
    clampQuantity();
  });
  quantity.addEventListener('change', clampQuantity);
  root.querySelectorAll('[data-pdp-preset]').forEach(button => button.addEventListener('click', () => {
    quantity.value = button.dataset.pdpPreset;
    clampQuantity();
    root.querySelectorAll('[data-pdp-preset]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
  }));

  function updatePrice() {
    const planValue = form.querySelector('[name="selling_plan"]')?.value;
    const allocation = variant.plans.find(plan => String(plan.id) === planValue);
    const price = allocation?.price ?? variant.price;
    const money = allocation?.money ?? variant.money;
    const multi = routineIds(selectedRoutine).length > 1;
    const totalMoney = multi ? new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {style:'currency', currency:window.Shopify?.currency?.active || 'INR', maximumFractionDigits:2}).format(Number(selectedRoutine.dataset.routinePrice) / 100) : money;
    root.querySelector('[data-pdp-price]').textContent = totalMoney;
    root.querySelector('[data-pdp-sticky-price]').textContent = totalMoney;
    const compare = root.querySelector('[data-pdp-compare]');
    const saving = root.querySelector('[data-pdp-saving]');
    compare.hidden = saving.hidden = multi || !variant.compare || variant.compare <= price;
    compare.textContent = variant.compareMoney || '';
    saving.textContent = compare.hidden ? '' : 'Save ' + Math.round((variant.compare - price) / variant.compare * 100) + '%';
  }
  function updateVariant(rebuildPlans = false) {
    variant = variants.find(item => String(item.id) === variantInput.value) || variants[0];
    routineCards.forEach(card => {
      const ids = routineIds(card);
      if (ids.length) { ids[0] = String(variant.id); card.dataset.routineVariantIds = ids.join(','); }
      card.dataset.routinePrice = String(variant.price + Number(card.dataset.addonPrice));
      card.dataset.routineBlocked = String(!variant.available || card.dataset.addonsAvailable !== 'true');
      card.querySelector('[data-routine-total]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {style:'currency',currency:window.Shopify?.currency?.active || 'INR',maximumFractionDigits:2}).format(Number(card.dataset.routinePrice)/100);
    });
    const available = variant.available && selectedRoutine?.dataset.routineBlocked !== 'true';
    const text = available ? (routineIds(selectedRoutine).length > 1 ? 'Add routine to cart' : 'Add to cart') : 'Sold out';
    add.textContent = stickyLabel.textContent = text;
    add.disabled = stickyAdd.disabled = !available || busy || uncertainAdd;
    if (buyButton) {
      buyButton.disabled = !available || busy || uncertainAdd;
      buyButton.textContent = busy ? buyButton.dataset.loadingLabel : buyButton.dataset.idleLabel;
    }
    const routineAdd = root.querySelector('[data-pdp-routine-add]');
    if (routineAdd) { routineAdd.disabled = !available || busy || uncertainAdd; routineAdd.textContent = available ? text : 'Selected routine unavailable'; }
    const stockLabels = JSON.parse(root.querySelector('[data-pdp-stock-labels]').textContent);
    const stock = root.querySelector('[data-pdp-stock]');
    const low = variant.available && variant.tracked && !variant.continueSelling && variant.inventory > 0 && variant.inventory <= 5;
    stock.textContent = variant.available ? (root.dataset.productHandle === 'online-vet-consultation' ? stockLabels.service : low ? stockLabels.low.replace('__COUNT__', variant.inventory) : variant.tracked && variant.inventory > 0 ? stockLabels.inStock : stockLabels.available) : stockLabels.soldOut;
    stock.classList.toggle('hp-card-facts__stock--low', low);
    const sku = root.querySelector('[data-pdp-sku]');
    sku.textContent = variant.sku ? 'SKU: ' + variant.sku : '';
    sku.hidden = !variant.sku;
    if (root.dataset.freshMeal === 'true') {
      const small = root.querySelector('[data-fresh-small]');
      const large = root.querySelector('[data-fresh-large]');
      small.dataset.pdpPreset = String(variant.min);
      large.dataset.pdpPreset = String(variant.max);
      small.replaceChildren(document.createTextNode(variant.min + ' packs'), Object.assign(document.createElement('span'), {textContent:'Smaller pack'}));
      large.replaceChildren(document.createTextNode(variant.max + ' packs'), Object.assign(document.createElement('span'), {textContent:'Larger pack'}));
    }
    quantity.min = String(variant.min);
    quantity.step = String(variant.step);
    quantity.max = variant.max == null ? '' : String(variant.max);
    clampQuantity();
    root.querySelectorAll('[data-pdp-preset]').forEach(button => button.setAttribute('aria-pressed', button.dataset.pdpPreset === quantity.value ? 'true' : 'false'));
    const checkout = form.querySelector('.hp-pdp__checkout');
    if (checkout) checkout.hidden = !available;
    const plans = form.querySelector('[data-pdp-plans]');
    if (plans && rebuildPlans) {
      const select = plans.querySelector('select');
      const old = select.value;
      select.replaceChildren();
      if (!requiredPlan) select.append(new Option('One-time purchase', ''));
      variant.plans.forEach(plan => select.append(new Option(plan.name + ' — ' + plan.money, String(plan.id))));
      if ([...select.options].some(option => option.value === old)) select.value = old;
      plans.hidden = !variant.plans.length;
    }
    updatePrice();
    updateShipping(null);
  }
  variantInput.addEventListener('change', () => {
    updateVariant(true);
    routineCards.forEach(card => {
      const ids = routineIds(card);
      if (ids.length) { ids[0] = String(variant.id); card.dataset.routineVariantIds = ids.join(','); }
    });
    status.textContent = '';
    if (variant.mediaId || variant.imageId) {
      const index = panels.findIndex(panel => variant.mediaId ? panel.dataset.mediaId === String(variant.mediaId) : panel.dataset.imageId === String(variant.imageId));
      if (index >= 0) showPanel(index);
    }
    const url = new URL(location.href);
    url.searchParams.set('variant', String(variant.id));
    history.replaceState(history.state, '', url);
  });
  form.querySelector('[name="selling_plan"]')?.addEventListener('change', updatePrice);
  updateVariant();

  const updateSticky = () => {
    const previewFrame = document.querySelector('#PBarNextFrame');
    const previewBar = document.querySelector('#PBarNextFrameWrapper') || previewFrame;
    const previewRect = previewFrame?.getBoundingClientRect().width ? previewBar.getBoundingClientRect() : null;
    const previewOffset = previewRect?.width && previewRect.height && previewRect.top > innerHeight / 2 ? Math.max(0,innerHeight - previewRect.top) : 0;
    document.documentElement.style.setProperty('--hp-pdp-preview-offset', previewOffset + 'px');
    const rect = add.getBoundingClientRect();
    const mainActionVisible = rect.bottom > 0 && rect.top < innerHeight - previewOffset;
    const modalOpen = [...document.querySelectorAll('dialog[open]')].some(dialog => dialog.getBoundingClientRect().width > 0);
    sticky.hidden = !matchMedia('(max-width:749px)').matches || rect.bottom > 0 || mainActionVisible || busy || modalOpen;
  };
  const observer = new IntersectionObserver(updateSticky);
  observer.observe(add);
  let stickyFrame = 0;
  window.addEventListener('scroll', () => {
    if (stickyFrame) return;
    stickyFrame = requestAnimationFrame(() => {stickyFrame = 0;updateSticky();});
  }, {passive:true});
  window.addEventListener('resize', updateSticky, {passive: true});
  document.querySelectorAll('dialog').forEach(dialog => {
    new MutationObserver(updateSticky).observe(dialog, {attributes:true,attributeFilter:['open']});
  });
  const watchPreview = () => {
    const frame = document.querySelector('#PBarNextFrame');
    if (!frame) return false;
    [frame,document.querySelector('#PBarNextFrameWrapper')].filter(Boolean).forEach(element => {
      new ResizeObserver(updateSticky).observe(element);
      new MutationObserver(updateSticky).observe(element, {attributes:true,attributeFilter:['style','hidden']});
    });
    updateSticky();
    return true;
  };
  if (!watchPreview()) {
    const previewObserver = new MutationObserver(() => {
      if (watchPreview()) previewObserver.disconnect();
    });
    previewObserver.observe(document.body, {childList:true,subtree:true});
  }
  updateSticky();
  const refreshShipping = () => fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {headers:{Accept:'application/json'}}).then(response => response.ok ? response.json() : null).then(cart => updateShipping(cart,shippingActual)).catch(() => {});
  refreshShipping();
  ['cart:update','cart:updated','cart:change','cart:refresh'].forEach(name => document.addEventListener(name,refreshShipping));
  stickyAdd.addEventListener('click', () => {
    if (!add.disabled) form.requestSubmit(add);
  });

  const completeAdd = async (cart, result, ids, quantityValue, buyNow) => {
    updateShipping(cart, true);
    const data = { source: 'product-form-component', productId: root.dataset.productId, itemCount: cart.item_count, sections: result.sections || {} };
    status.textContent = 'Added to your cart.';
    if (buyNow) {
      data.source = 'hp-buy-now';
      document.dispatchEvent(new CustomEvent('cart:update', { detail: { resource: cart, data } }));
      const addedTitle = cart.items.filter(item => ids.includes(String(item.variant_id))).map(item => `${quantityValue} × ${item.product_title}`).join(', ');
      const decision = window.hpCheckoutUpsell ? await window.hpCheckoutUpsell.offer(cart, { trigger: 'buy-now', anchorIds: ids, addedTitle }) : 'continue';
      if (decision === 'continue') {
        if (window.hpCheckoutGuard) await window.hpCheckoutGuard.checkout({ skipOffers: true });
        else location.assign((window.Shopify?.routes?.root || '/') + 'cart');
      }
    } else {
      root.dispatchEvent(new CartAddEvent(cart, ids.join(','), data));
      if (!document.querySelector('cart-drawer-component')) location.assign((window.Shopify?.routes?.root || '/') + 'cart');
    }
  };

  const showUncertainAdd = () => {
    uncertainAdd = true;
    status.textContent = buyButton.dataset.uncertainLabel + ' ';
    const link = document.createElement('a');
    link.href = (window.Shopify?.routes?.root || '/') + 'cart';
    link.textContent = buyButton.dataset.reviewLabel;
    status.append(link);
  };

  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (busy || uncertainAdd || !variant.available || selectedRoutine?.dataset.routineBlocked === 'true') return;
    const buyNow = event.submitter?.hasAttribute('data-pdp-buy-now') === true;
    let sent = false;
    clampQuantity();
    if (!form.reportValidity()) return;
    busy = true;
    add.disabled = stickyAdd.disabled = true;
    if (buyButton) { buyButton.disabled = true; buyButton.textContent = buyButton.dataset.loadingLabel; }
    add.textContent = 'Adding…';
    const routineAdd = root.querySelector('[data-pdp-routine-add]');
    if (routineAdd) { routineAdd.disabled = true; routineAdd.textContent = 'Adding…'; }
    status.textContent = '';
    form.setAttribute('aria-busy', 'true');
    updateSticky();
    const rootUrl = window.Shopify?.routes?.root || '/';
    const selectedIds = routineIds(selectedRoutine);
    const isRoutine = selectedIds.length > 1 && selectedRoutine?.dataset.routineBlocked !== 'true';
    if (isRoutine) {
      try {
        const quantityValue = Math.max(1, Number(quantity.value || 1));
        const selectedPlan = new FormData(form).get('selling_plan');
        const items = selectedIds.map(id => ({ id: Number(id), quantity: quantityValue, ...(String(id) === String(variant.id) && selectedPlan ? { selling_plan: selectedPlan } : {}) }));
        const sectionIds = [...new Set([...document.querySelectorAll('cart-items-component')].map(component => component.dataset.sectionId).filter(Boolean))].slice(0,5);
        sent = true;
        const response = await fetch(rootUrl + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'}, body:JSON.stringify({items, sections:sectionIds, sections_url:location.pathname})});
        const result = await response.json();
        if (!response.ok || result.status) { sent = false; status.textContent = result.description || 'This routine could not be added. Please choose another option.'; return; }
        let cart = null;
        for (let attempt = 0; attempt < 2; attempt++) {
          try {
            const cartResponse = await fetch(rootUrl + 'cart.js', {headers:{Accept:'application/json'}});
            if (cartResponse.ok) {
              const currentCart = await cartResponse.json();
              if (Number.isInteger(currentCart.item_count) && Array.isArray(currentCart.items) && Number.isFinite(currentCart.total_price)) {
                cart = currentCart;
                break;
              }
            }
          } catch {}
        }
        if (!cart) {
          if (buyNow) uncertainAdd = true;
          status.textContent = 'Added to your cart. Open the cart to review your items.';
          location.assign(rootUrl + 'cart');
          return;
        }
        await completeAdd(cart, result, selectedIds, quantityValue, buyNow);
      } catch { if (buyNow && sent) showUncertainAdd(); else status.textContent = 'We could not confirm the request. Please check your cart before trying again.'; }
      finally { const actual = shippingActual; busy = false; form.removeAttribute('aria-busy'); updateVariant(); if (actual) updateShipping(shippingCart,true); updateSticky(); }
      return;
    }
    const data = new FormData(form);
    const sectionIds = [...new Set([...document.querySelectorAll('cart-items-component')].map(component => component.dataset.sectionId).filter(Boolean))].slice(0, 5);
    if (sectionIds.length) data.set('sections', sectionIds.join(','));
    data.set('sections_url', location.pathname);
    try {
      sent = true;
      const response = await fetch(rootUrl + 'cart/add.js', {method:'POST', headers:{Accept:'application/json'}, body:data});
      const result = await response.json();
      if (!response.ok || result.status) {
        sent = false;
        status.textContent = result.description || result.message || 'This option could not be added. Please check availability.';
        return;
      }
      const cartResponse = await fetch(rootUrl + 'cart.js', {headers:{Accept:'application/json'}});
      if (!cartResponse.ok) {
        if (buyNow) showUncertainAdd();
        else
        status.textContent = 'Added to your cart. Open the cart to review your items.';
        return;
      }
      const cart = await cartResponse.json();
      await completeAdd(cart, result, [String(variant.id)], Number(quantity.value), buyNow);
    } catch {
      if (buyNow && sent) showUncertainAdd();
      else status.textContent = 'We could not confirm the request. Please check your cart before trying again.';
    } finally {
      const actual = shippingActual;
      busy = false;
      form.removeAttribute('aria-busy');
      updateVariant();
      if (actual) updateShipping(shippingCart,true);
      updateSticky();
    }
  });
}
const arrowIcon = direction => `<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="${direction < 0 ? 'M14 6l-6 6 6 6' : 'M10 6l6 6-6 6'}" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
function initialiseNavigation() {
  document.querySelectorAll('.hp-pdp__arrow').forEach(button => {
    button.innerHTML = arrowIcon(button.hasAttribute('data-pdp-prev') ? -1 : 1);
  });
  const rows = [
    ['.hp-pdp__routine-cards', 'play routines'],
    ['.hp-pdp__kit-grid', 'HeartyBoxes'],
    ['.hp-pdp__meal-grid', 'meal combos'],
    ['.hp-pdp-related__grid', 'related products'],
    ['.hp-pdp__thumbs', 'product thumbnails']
  ];
  rows.forEach(([selector, label]) => document.querySelectorAll(selector).forEach(row => {
    if (row.dataset.navigationBound) return;
    row.dataset.navigationBound = 'true';
    const controls = document.createElement('div');
    controls.className = 'hp-pdp-scroll-nav';
    controls.hidden = true;
    const counter = document.createElement('span');
    counter.className = 'hp-pdp-scroll-nav__count';
    const buttons = [-1,1].map(direction => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'hp-pdp-scroll-nav__button';
      button.setAttribute('aria-label', `${direction < 0 ? 'Previous' : 'Next'} ${label}`);
      button.innerHTML = arrowIcon(direction);
      button.addEventListener('click', () => {
        const first = row.firstElementChild;
        const distance = first ? first.getBoundingClientRect().width + parseFloat(getComputedStyle(row).columnGap || 0) : row.clientWidth;
        row.scrollBy({left:direction * distance, behavior:matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth'});
      });
      return button;
    });
    controls.append(counter,...buttons);
    row.before(controls);
    const update = () => {
      const max = row.scrollWidth - row.clientWidth;
      controls.hidden = max <= 3;
      buttons[0].disabled = row.scrollLeft <= 3;
      buttons[1].disabled = row.scrollLeft >= max - 3;
      const children = [...row.children];
      const left = row.getBoundingClientRect().left;
      const index = children.findIndex(child => child.getBoundingClientRect().right > left + 20);
      counter.textContent = `${Math.max(1,index + 1)} / ${children.length}`;
    };
    row.addEventListener('scroll',update,{passive:true});
    new ResizeObserver(update).observe(row);
    update();
  }));
}
const initialiseAll = () => {
  document.querySelectorAll('[data-hp-pdp]').forEach(initialise);
  initialiseNavigation();
};
initialiseAll();
document.addEventListener('shopify:section:load', initialiseAll);


